import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import DocumentsApi from '../generated/api/Documents';
import SihaUploadDocumentRequestViewModel from '../viewModel/request/Documents/SihaUploadDocumentRequestViewModel';

export default (service: Servicelayer) => ({
  ...DocumentsApi(service),

  async sihaDownloadFile(id: string) {
    const document = await this.sihaGetDocumentByExternalId(id);
    const imageBlob = await this.sihaDownloadDocument(id);
    return new File([imageBlob], document.originalFileName ?? '', { type: document.contentType ?? undefined });
  },

  async sihaUploadMultipleDocuments(documents: File[]) {
    const allPromises = [] as Promise<string | undefined>[];
    documents.forEach((document) => {
      const request = new SihaUploadDocumentRequestViewModel();
      request.uploadFile = document;
      const promise = service.api.documents.sihaUploadDocument(request);
      allPromises.push(promise);
    });
    const allIds = await Promise.all(allPromises) as string[];
    return allIds;
  },

});
